import { render } from "./SignInComponent.vue?vue&type=template&id=5e48d69a"
import script from "./SignInComponent.vue?vue&type=script&lang=js"
export * from "./SignInComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\_Hamza\\_Code\\HealthAcademy\\SCFHSHealthAcademyPublic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__